import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  TableContainer,
  Select,
  Paper,
  TextField,
  IconButton,
  Box,
   Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,Tooltip,
  Button,
  Autocomplete,
  CircularProgress,
  Checkbox,
  MenuItem,
  InputLabel,
  FormControl,
   Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,OutlinedInput,ListItemText,FormHelperText
} from "@mui/material";
import { GlobalStyles, margin } from "@mui/system";
import { useAuth } from "../../../AuthProvider";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import DeleteIcon from "@mui/icons-material/Delete";
import Chip from "@mui/material/Chip";
import { useNavigate } from "react-router-dom";

import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

function Trips() {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const { userId, oId,role,pId,feature } = useAuth();
  const navigate = useNavigate();

  
  const [tripsData, setTripsdata] = useState([]);
  const [meetings, setMeetings] = useState([]); // State to store fetched data
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [loadingData, setLoadingData] = useState(true); // ✅ Define loading state


  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState('');
  const isPrincipal = role?.startsWith("PRINCIPAL") || false;
  const UserId = userId || selectedUsers;




// post foem states
const [trips, setTrips] = useState([]);
const [stops, setStops] = useState([]);
const [busNumbers, setBusNumbers] = useState([]);


const [selectedTrip, setSelectedTrip] = useState("");
const [selectedStops, setSelectedStops] = useState([]);
const [selectedBusNumber, setSelectedBusNumber] = useState("");

//table states 
  const [busNumber, setbusNumber] = useState([]);
 const [selectedBus, setSelectedBus] = useState("");


//Dialog states
  const [selectedRow, setSelectedRow] = useState(null); // To store the row to edit
  const [isDialogOpen, setDialogOpen] = useState(false); // Dialog open state
  const [busRoutes, setBusRoutes] = useState([]);
  const [dialogbtnloading, setDialogbtnloading] = useState(false); // State for loading

  const [dialogStops, setDialogStops] = useState([]);



  const [searchQuery, setSearchQuery] = useState("");

const filteredMeetings = tripsData.filter((data) => {
  const query = searchQuery.toLowerCase();

  return (
    (data.busId && data.busId.toLowerCase().includes(query)) ||
    (data.route && data.route.toLowerCase().includes(query))
  );
});


   const fetchUsers = async () => {
        try {
            const response = await fetch(`${baseUrl}/api/principal/getAllUserIdsAndNames/SCHEDULE_MEETING/${oId}/${pId}`);
            if (!response.ok) {
                throw new Error('Failed to fetch users');
            }
            const data = await response.json();
            setUsers(data);
            if (data.length > 0) {
              setSelectedUsers(data[0].userId); // ✅ Set first record's userId as default
          }
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
 useEffect(() => {
  if (isPrincipal) {
    fetchUsers();
  }
}, []); // ✅ Only runs on mount 



// Fetch bus numbers
const fetchBusNumbers = async () => {
  try {
    const response = await fetch(`${baseUrl}/api/SchedulingRoute/bus-numbers-numberPlate/${pId}`);
    if (!response.ok) throw new Error("Failed to fetch bus numbers");
    const data = await response.json();

    // ✅ store the full array of objects
    setBusNumbers(data); 
    setbusNumber(data); 

    // ✅ default selection = first busNumber
    if (data.length > 0) {
      setSelectedBusNumber(data[0].busNumber);
    }
  } catch (error) {
    console.error("Error fetching bus numbers:", error);
  }
};


useEffect(() => {
  fetchBusNumbers();
   if (selectedBusNumber) {
    fetchTrips(selectedBusNumber);  // update trips
    fetchStops(selectedBusNumber);  // update stops
  }
}, []);

// Fetch trips
const fetchTrips = async () => {
    if(!selectedBusNumber) return;
  try {
    const response = await fetch(`${baseUrl}/api/SchedulingRoute/getAll/trips/${selectedBusNumber}`); // replace with your endpoint
    if (!response.ok) throw new Error("Failed to fetch trips");
    const data = await response.json();
    setTrips(data);
  } catch (error) {
    console.error("Error fetching trips:", error);
  }
};

useEffect(() => {
  fetchTrips();
}, [selectedBusNumber]);

// Fetch stops
const fetchStops = async () => {
    if(!selectedBusNumber) return;
  try {
    const response = await fetch(`${baseUrl}/api/SchedulingRoute/getAll/stops/${selectedBusNumber}`);
    if (!response.ok) throw new Error("Failed to fetch stops");
    const data = await response.json();
    setStops(data);
  } catch (error) {
    console.error("Error fetching stops:", error);
  }
};



useEffect(() => {
  fetchStops();
}, [selectedBusNumber]);




  // for getAll api
  const fetchTripsTabledata = async () => {
    if (!selectedBus) {
      setLoadingData(false); // Ensure loading state is removed if no bus is selected
      return; 
    }
    setLoadingData(true); // Start loading
    try {
      const response = await fetch(
        `${baseUrl}/api/SchedulingRoute/getAll/bustrips/${selectedBus}`
      );
      const data = await response.json();

      if (Array.isArray(data)) {
        setTripsdata(data); // Assuming `setMeetings` is your state setter
      } else {
        console.error("API response is not an array:", data);
        setTripsdata([]); // Set to an empty array if response is invalid
      }
    } catch (error) {
      setTripsdata([]);
      console.error(error);
      // toast.error(error.message);
    } finally {
      setLoadingData(false); // Stop loading
    }
  };
  useEffect(() => {
  if (busNumbers.length > 0 && !selectedBus) {
    setSelectedBus(busNumbers[0].busNumber); // ✅ set default bus first
  } else {
    fetchTripsTabledata(); // ✅ then fetch trips
  }
}, [selectedBus, busNumbers]);



const validateForm = () => {
  const newErrors = {};

  if (!selectedTrip) newErrors.route = "Trip selection is required";
  if (!selectedStops.length) newErrors.stop = "Select at least one stop";
  if (!selectedBusNumber) newErrors.busId = "Bus number selection is required";

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};


const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  if (!validateForm()) {
    setLoading(false);
    return;
  }

  try {
    // Build repeated stops query parameters
    const queryParams = selectedStops
      .map((stop) => `stops=${encodeURIComponent(stop)}`)
      .join("&");

    const url = `${baseUrl}/api/SchedulingRoute/update/trips/${selectedBusNumber}/${selectedTrip}?${queryParams}`;

    const response = await fetch(url, {
      method: "PATCH",
    });

    if (!response.ok) throw new Error("Failed to schedule route");

    toast.success("Form submitted successfully", { autoClose: 1000 });
    setSelectedStops([]);
    setSelectedTrip("");
    fetchTripsTabledata();
     fetchStops();
  } catch (error) {
    toast.error(error.message);
  } finally {
    setLoading(false);
  }
};


 const handleEditClick = (row) => {
    setSelectedRow(row); // Set the selected row
    setDialogOpen(true); // Open the dialog
  };



  const handleDialogClose = () => {
    setDialogOpen(false); // Close the dialog
    setSelectedRow(null); // Clear the selected row
  };


  // Dialog Fetch Based on trips stops are showing
const fetchDialogStops = async () => {
  if (!selectedRow?.busId || !selectedRow?.route) return;
  try {
    const response = await fetch(
      `${baseUrl}/api/SchedulingRoute/available/stops/bus/${selectedRow.busId}/${selectedRow.route}/${oId}/${pId}`
    );
    if (!response.ok) throw new Error("Failed to fetch trips");
    const data = await response.json();

    // Defensive: ensure data.stops is an array
    const stopsArray = Array.isArray(data?.stops) ? data.stops.map(s => s.trim()) : [];
    setDialogStops(stopsArray);
  } catch (error) {
    setDialogStops([]);
    console.error("Error fetching trips:", error);
  }
};



useEffect(() => {
  fetchDialogStops();
}, [selectedRow]);


// const handleSaveChanges = async () => {
//   if (!selectedRow?.busId || !selectedRow?.route) {
//     toast.error("Invalid selection. Please select a valid row.");
//     return;
//   }

//   const selectedStopsArray = selectedRow?.stop
//     ? selectedRow.stop.split(",").map((s) => s.trim()).filter((s) => s !== "")
//     : [];

//   if (selectedStopsArray.length === 0) {
//     toast.error("Please select at least one stop before saving.");
//     return;
//   }

//   setDialogbtnloading(true); // Start loading

//   try {
//     // Build repeated stops query parameters: stops=Stop1&stops=Stop2...
//     const queryParams = selectedStopsArray
//       .map((stop) => `stops=${encodeURIComponent(stop)}`)
//       .join("&");

    
//     const url = `${baseUrl}/api/SchedulingRoute/change/stops/${selectedRow.busId}/${selectedRow.route}?${queryParams}`;

//     const response = await fetch(url, {
//       method: "PATCH",
//     });

//     const responseData = await response.json();

//     if (!response.ok) {
//       throw new Error(
//         responseData.message || "Failed to update the details."
//       );
//     }

//     console.log("Update successful:", responseData);
//     toast.success("Details updated successfully!");
//     fetchTripsTabledata();
//     handleDialogClose(); // Close the dialog after successful update
//   } catch (error) {
//     console.error("Error updating details:", error);
//     toast.error(`Error updating details: ${error.message}`);
//   } finally {
//     setDialogbtnloading(false); // Stop loading
//   }
// };

const handleSaveChanges = async () => {
  if (!selectedRow?.busId || !selectedRow?.route) {
    toast.error("Invalid selection. Please select a valid row.");
    return;
  }

  const selectedStopsArray = selectedRow?.stop
    ? selectedRow.stop.split(",").map((s) => s.trim()).filter((s) => s !== "")
    : [];

  if (selectedStopsArray.length === 0) {
    toast.error("Please select at least one stop before saving.");
    return;
  }

  setDialogbtnloading(true); // Start loading

  try {
    // Build repeated stops query parameters: stops=Stop1&stops=Stop2...
    const queryParams = selectedStopsArray
      .map((stop) => `stops=${encodeURIComponent(stop)}`)
      .join("&");

    const url = `${baseUrl}/api/SchedulingRoute/change/stops/${selectedRow.busId}/${selectedRow.route}?${queryParams}`;

    const response = await fetch(url, {
      method: "PATCH",
    });

    const responseText = await response.text(); // parse as text!

    if (!response.ok) {
      throw new Error(
        responseText || "Failed to update the details."
      );
    }

    console.log("Update successful:", responseText);

    // Show toast with server response or fallback message
    toast.success(responseText || "Stops updated successfully!");
    fetchTripsTabledata();
      fetchStops();
    handleDialogClose(); // Close the dialog after successful update
  } catch (error) {
    console.error("Error updating details:", error);
    toast.error(`Error updating details: ${error.message}`);
  } finally {
    setDialogbtnloading(false); // Stop loading
  }
};





  const handleDeleteMeeting = (data) => {
    Swal.fire({
      title: "Are you sure?",

      text: `You Want To Delete "${data.title}" From The Meeting List.`,

      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      // ✅ Using async here
      if (result.isConfirmed) {
        try {
          const response = await fetch(
            `${baseUrl}/api/parentMeeting/deleteMeeting/${data.id}/${oId}`,
            { method: "DELETE" }
          );

          if (!response.ok) throw new Error("Failed to delete the meeting");
        

          // Swal.fire("Deleted!");
          toast.success("Your meeting has been deleted.", "success");
        } catch (error) {
          // Swal.fire("Error!", error.message, "error");
          toast.error(error.message);
        }
      }
    });
  };

  return (
    <Card
      style={{
        margin: "60px 20px",
        padding: "10px",
        backgroundColor: "#fff",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
      }}
    >
      <CardContent>
        <Typography
          variant="h4"
          style={{ fontWeight: "bold", color: "#333", textAlign: "center" }}
        >
          Schedule Bus Trips
        </Typography>

        <Grid
          container
          spacing={2}
          sx={{ marginTop: "10px", alignItems: "center" }}
        >
          <Grid item xs={12} md={4}>
            <Box
              sx={{
                padding: "15px",
                borderRadius: "8px",
                boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.25)",
                backgroundColor: "#ffffff",
                // height: "100%", // Ensure both sections have the same height
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#333", marginBottom: "15px" }}
              >
                Schedule Bus Trip
              </Typography>

              <form onSubmit={handleSubmit} style={{ flexGrow: 1 }}>
  {/* Bus Number Field */}
<FormControl fullWidth sx={{ mb: 2 }} error={!!errors.busId}>
  <InputLabel>Select Bus Number</InputLabel>
  <Select
    value={selectedBusNumber}
    onChange={(e) => {
    const newBusNumber = e.target.value;
    setSelectedBusNumber(newBusNumber);

    // Reset dependent fields
    setSelectedTrip("");      // clear trip
    setSelectedStops([]);     // clear stops

    setErrors((prev) => ({
      ...prev,
      busId: "",
      route: "",      // reset trip error
      stop: "",       // reset stops error
    }));

    // Optionally, fetch trips and stops for the selected bus
    fetchTrips(newBusNumber);
    fetchStops(newBusNumber);
  }}
    label="Select Bus Number"
  >
    {busNumbers.length === 0 ? (
      <MenuItem disabled value="">
        No Bus Numbers Available
      </MenuItem>
    ) : (
      busNumbers.map((bus) => (
        <MenuItem key={bus.busNumber} value={bus.busNumber}>
          {bus.busNumberPlate} {/* ✅ Show plate only */}
        </MenuItem>
      ))
    )}
  </Select>
  <FormHelperText>{errors.busId}</FormHelperText>
</FormControl>



  {/* Trip Field */}
<FormControl fullWidth sx={{ mb: 2 }} error={!!errors.route}>
  <InputLabel>Select Trip</InputLabel>
  <Select
    value={selectedTrip}
    onChange={(e) => {
      setSelectedTrip(e.target.value);
      setErrors((prev) => ({ ...prev, route: "" }));
    }}
    label="Select Trip"
  >
    {trips.length === 0 ? (
      <MenuItem disabled value="">
        Select Bus Number to Show Trips
      </MenuItem>
    ) : (
      trips.map((trip) => (
        <MenuItem key={trip} value={trip}>
          {trip}
        </MenuItem>
      ))
    )}
  </Select>
  <FormHelperText>{errors.route}</FormHelperText>
</FormControl>




  {/* Stops Field */}
{/* <FormControl fullWidth sx={{ mb: 2, }} error={!!errors.stop}>
  <InputLabel>Select Stops</InputLabel>
  <Select
    multiple
    value={selectedStops}
    onChange={(e) => {
      setSelectedStops(e.target.value);
      setErrors((prev) => ({ ...prev, stop: "" }));
    }}
    input={<OutlinedInput label="Select Stops" />}
    renderValue={(selected) => selected.join(", ")}
  >
    {stops.length === 0 ? (
      <MenuItem disabled value="">
        Select Bus Number to Show Stops
      </MenuItem>
    ) : (
      stops.map((stop) => (
        <MenuItem key={stop} value={stop}>
          <Checkbox checked={selectedStops.includes(stop)} />
          <ListItemText primary={stop} />
        </MenuItem>
      ))
    )}
  </Select>
  <FormHelperText>{errors.stop}</FormHelperText>
</FormControl> */}


{/* 
<FormControl fullWidth sx={{ mb: 2 }} error={!!errors.stop}>
  <InputLabel>Select Stops</InputLabel>
  <Select
    multiple
    value={selectedStops}
    onChange={(e) => {
      setSelectedStops(e.target.value);
      setErrors((prev) => ({ ...prev, stop: "" }));
    }}
    input={<OutlinedInput label="Select Stops" />}
    renderValue={(selected) => `${selected.length} stop(s) selected`}
  >
    {stops.length === 0 ? (
      <MenuItem disabled value="">
        Select Bus Number to Show Stops
      </MenuItem>
    ) : (
      stops.map((stop) => (
        <MenuItem key={stop} value={stop}>
          <Checkbox checked={selectedStops.includes(stop)} />
          <ListItemText primary={stop} />
        </MenuItem>
      ))
    )}
  </Select>
  <FormHelperText>{errors.stop}</FormHelperText>
</FormControl> */}

<FormControl fullWidth sx={{ mb: 2 }} error={!!errors.stop}>
  <InputLabel>Select Stops</InputLabel>
  <Tooltip
    title={
      selectedStops.length > 0
        ? selectedStops.join(", ")
        : "No stops selected"
    }
    placement="top" // or 'bottom', 'right', etc.
    arrow
  >
    <Select
      multiple
      value={selectedStops}
      onChange={(e) => {
        setSelectedStops(e.target.value);
        setErrors((prev) => ({ ...prev, stop: "" }));
      }}
      input={<OutlinedInput label="Select Stops" />}
      renderValue={(selected) => `${selected.length} stop(s) selected`}
    >
      {stops.length === 0 ? (
        <MenuItem disabled value="">
          Select Bus Number to Show Stops
        </MenuItem>
      ) : (
        stops.map((stop) => (
          <MenuItem key={stop} value={stop}>
            <Checkbox checked={selectedStops.includes(stop)} />
            <ListItemText primary={stop} />
          </MenuItem>
        ))
      )}
    </Select>
  </Tooltip>
  <FormHelperText>{errors.stop}</FormHelperText>
</FormControl>




  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
    <Button
      type="submit"
      variant="contained"
      color="primary"
      sx={{
        backgroundColor: "#6E69B0",
        color: "white",
        marginTop: "10px",
        minWidth: "130px",
        "&:hover": { backgroundColor: "#58548E" },
      }}
      disabled={loading}
    >
      {loading ? (
        <CircularProgress size={24} sx={{ color: "white" }} />
      ) : (
        "Schedule Route"
      )}
    </Button>
  </Box>
</form>

            </Box>
          </Grid>

          <Grid item xs={12} md={8}>
            <Box
              sx={{
                padding: "15px",
                borderRadius: "8px",
                boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.25)",
                backgroundColor: "#f9f9f9",
              }}
            >
              <Typography
                variant="h5"
                sx={{ fontWeight: "bold", color: "#333", marginBottom: "15px" }}
              >
                Scheduled Route Trips
              </Typography>

             <Grid
  container
  spacing={2} // adds consistent gap between items
  alignItems="center" // vertically align inputs
  sx={{ mb: 2 }} // shorter marginBottom shorthand
>
  {/* Search field */}
  <Grid item xs={6} sm={4}>
    <TextField
      label="Search by Bus No or Trip"
      size="small"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      placeholder="Bus No or Trip"
      fullWidth
    />
  </Grid>

  {/* Select Bus */}
  <Grid item xs={6} sm={4}>
    <FormControl fullWidth variant="outlined" size="small">
  <InputLabel id="bus-select-label" sx={{ fontSize: "12px" }}>
    Select Bus
  </InputLabel>
  <Select
    labelId="bus-select-label"
    value={selectedBus}
    onChange={(e) => setSelectedBus(e.target.value)}
    label="Select Bus"
    sx={{ height: "35px", fontSize: "13px" }}
  >
    {busNumber.map((bus, index) => (
      <MenuItem key={index} value={bus.busNumber}>
        {bus.busNumberPlate} {/* ✅ show only Plate */}
      </MenuItem>
    ))}
  </Select>
</FormControl>

  </Grid>
</Grid>


              <Box
                sx={{ borderBottom: "1px solid #ddd", marginBottom: "15px" }}
              />

              <GlobalStyles
                styles={{
                  ".custom-sidebar-scrollbar": {
                    scrollbarWidth: "thin", // For Firefox
                    scrollbarColor: "grey #e0e0e0",
                  },
                  ".custom-sidebar-scrollbar::-webkit-scrollbar": {
                    width: "6px", // For WebKit-based browsers
                  },
                  ".custom-sidebar-scrollbar::-webkit-scrollbar-track": {
                    background: "#f1f1f1", // Track color
                  },
                  ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb": {
                    backgroundColor: "grey", // Thumb color
                    borderRadius: "10px",
                  },
                  ".custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#555",
                  },
                }}
              />

                {/* Table Section */}
        <TableContainer
          component={Paper}
          style={{
            marginTop: "20px",
            borderRadius: "8px",
            maxHeight: "400px",
            overflowY: "auto",
          }}
          className="custom-sidebar-scrollbar"
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                    fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  S.No
                </TableCell>
                
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  Bus No
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold' ,
                    fontSize:'14px'
                  }}
                >
                  Trip
                </TableCell>
                 <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold' ,
                    fontSize:'14px'
                  }}
                >
                  Stops
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: "1px solid #ddd",
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold' ,
                    fontSize:'14px'
                  }}
                >
                  Action
                </TableCell>
               
                
                {feature === "ULTRA" && (
                <TableCell
                  sx={{
                    padding: "2px",
                    textAlign: "center",
                    backgroundColor: "#fff9c4",
                     fontWeight:'bold',
                    fontSize:'14px'
                  }}
                >
                  View
                </TableCell>
                )}
              </TableRow>
            </TableHead>

            <TableBody>
              {loadingData ? (
                <TableRow>
                <TableCell colSpan={6} style={{ textAlign: "center", padding: "20px" }}>
                  <Box display="flex" flexDirection="column" alignItems="center">
                    <CircularProgress />
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      Loading Data...
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
              
              ) : filteredMeetings.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} style={{ textAlign: "center" }}>
                    No data found.
                  </TableCell>
                </TableRow>
              ) : (
                filteredMeetings.map((row, index) => (
                  <TableRow
                    key={row.id}
                    style={{
                      backgroundColor: "white",
                      transition: "background-color 0.3s",
                      height: "40px",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = "#f5f5f5";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "white";
                    }}
                  >
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {index + 1}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.busNumberPlate}
                    </TableCell>
                  
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderRight: "1px solid #ddd",
                        padding: "2px",
                      }}
                    >
                      {row.route}
                    </TableCell>
                  
                    
                   <TableCell
  sx={{
    textAlign: "center",
    borderRight: "1px solid #ddd",
    padding: "2px",
    maxWidth: "200px",
    overflow: "hidden",
  }}
>
  <div
    style={{
      display: "block",
      maxHeight: "60px",
      overflowY: "auto",
      overflowX: "hidden",
      textAlign: "center",
      wordWrap: "break-word",
      whiteSpace: "normal",
    }}
  >
    {(() => {
      try {
        const stopsArray = JSON.parse(row.stop);
        if (Array.isArray(stopsArray)) {
          return stopsArray.join(", ");
        }
        return row.stop;
      } catch (e) {
        return row.stop; // fallback for invalid JSON
      }
    })()}
  </div>
</TableCell>
  <TableCell sx={{ textAlign: "center", padding: "2px", borderRight: "1px solid #ddd", }}>
                       <Box
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    gap: "4px",
                                                  }}
                                                >
                 
                        <Button
                                                    sx={{
                                                      backgroundColor: "#1565c0",
                                                      color: "white",
                                                      "&:hover": { backgroundColor: "#0d47a1" },
                                                      // borderRadius: 2,
                                                      padding: "2px 4px",
                                                    }}
                                                    onClick={() => handleEditClick(row)}
                                                  >
                                                    Edit
                                                  </Button>
                                                  </Box>
                    </TableCell>

                  {feature === "ULTRA" &&(
                    <TableCell sx={{ textAlign: "center", padding: "2px" }}>
                       <Box
                                                  sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    gap: "4px",
                                                  }}
                                                >
                 
                       <Button
                                                    sx={{
                                                      backgroundColor: "#1565c0",
                                                      color: "white",
                                                      "&:hover": { backgroundColor: "#0d47a1" },
                                                      // borderRadius: 2,
                                                      padding: "2px 4px",
                                                    }}
                                              
                                                    onClick={() => {
                                                      navigate("/BusTracking", {
                                                        state: {
                                                          busId: row.busId,
                                                          route: row.route,
                                                        },
                                                      });
                                                    }}

                                                  >
                                                    View Route
                                                  </Button>
                                                  </Box>
                    </TableCell>
                      )}

                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>



        
                {/* Dialog for editing */}
                <Dialog open={isDialogOpen} onClose={handleDialogClose} size="xs">
                  <DialogTitle style={{ fontWeight: "bold"}}>Edit Details</DialogTitle>
                  <DialogContent>
                    <Grid container spacing={1}>
                      <Grid  fullWidth item xs={12}>
                        <TextField
                          label="Bus No"
                          value={selectedRow ? selectedRow.busNumberPlate : ""}
                          onChange={(e) =>
                            setSelectedRow((prevState) => ({
                              ...prevState,
                              busNumberPlate: e.target.value,
                            }))
                          }
                          fullWidth
                          margin="normal"
                          disabled
                          InputProps={{
                            style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
                          }}
                        />
                      </Grid>
        
                      <Grid item xs={12} fullWidth>
                        <TextField
                          label="Trip"
                          value={selectedRow ? selectedRow.route : ""}
                          onChange={(e) =>
                            setSelectedRow((prevState) => ({
                              ...prevState,
                              route: e.target.value,
                            }))
                          }
                          fullWidth
                          margin="normal"
                          disabled
                          InputProps={{
                            style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'},
                          }}
                        />
                      </Grid>
                     
                  
                      <Grid item xs={12} fullWidth>
  <FormControl fullWidth margin="normal">
    <InputLabel>Select Stops</InputLabel>
    <Select
      multiple
      value={
        selectedRow?.stop
          ? selectedRow.stop.split(",").map((s) => s.trim())
          : []
      }
      onChange={(e) => {
        const selectedStops = e.target.value;
        setSelectedRow((prevState) => ({
          ...prevState,
          stop: selectedStops.join(","), // save as comma-separated string again
        }));
      }}
      input={<OutlinedInput label="Select Stops" />}
      renderValue={(selected) => selected.join(", ")}
    >
      {dialogStops.map((stop) => (
        <MenuItem key={stop} value={stop}>
          <Checkbox
            checked={
              selectedRow?.stop
                ? selectedRow.stop.split(",").includes(stop)
                : false
            }
          />
          <ListItemText primary={stop} />
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>








                    </Grid>
                  </DialogContent>
                  <DialogActions>
                  <Button
          onClick={handleDialogClose}
          color="primary"
          variant="outlined"
        
        >
          Cancel
        </Button>
        
        <Button
          onClick={handleSaveChanges}
          color="primary"
          variant="contained"
          disabled={dialogbtnloading} // Disable when loading
          sx={{
            fontWeight: 600,
            backgroundColor: "#3C3972",
            "&:hover": { backgroundColor: "#3C3972" },
          }}
        >
          {dialogbtnloading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Save"}
        </Button>
        
                  </DialogActions>
                </Dialog>





            </Box>
          </Grid>
        </Grid>
      </CardContent>
      <ToastContainer position="top-right" autoClose={1000} />
    </Card>
  );
}

export default Trips;